import { IPartner } from 'clickNgo/entities/partner/models'

interface IRenderTableProperties {
  item: IPartner
  fieldName: keyof IPartner
}

export const renderTableProperties = ({ item, fieldName }: IRenderTableProperties) => {
  return <>{item[fieldName] || '-'}</>
}
